'use strict';

import ajax from '../../ajax';
import formPrepare from './formPrepare';
import util from '../../util';
// import cardValidation from './card-validation';
import validator from '../../validator';
import summarysection from '../summarysection';
import index from '../product/index';
import customModal from '../../modal';
import newAddressForm from '../../addressForm/address-form';
import checkoutAddress from './address';
import googleAddressAutocomplete from './googleAddressAutocomplete';
import adyenCheckout from '../../adyen/adyen-checkout';
import { global as modal } from '../../modal';
import tooltip from '../../tooltip';
import inputField from '../../addressForm/input-field';
import selectMenu from '../../addressForm/selectmenu';
import oospaymentmodal from '../../modal';

const paybylink = oospaymentmodal.create(
  '#payment-paybylink-order-model-content',
  '#payment-paybylink-popup',
  {}
);

const freeorder = oospaymentmodal.create(
  '#payment-free-order-model-content',
  '#payment-paybylink-popup',
  {}
);

var $cache;
var isOOBPaymentInstrumentsConfirmed = false;

$('input[name="brandCode"]').on('change', function () {
  $('#dwfrm_adyPaydata_issuer').val('');
  $('.checkoutComponent').hide();
  $("#component_".concat($(this).val())).show();
});

if($("form").hasClass("checkout-billing")){
	$(document).keypress(function(e) {
	    var code = (e.keyCode ? e.keyCode : e.which);
	    if ( (code==13) || (code==10)){//android and ios GO button
	    	e.preventDefault();
			e.stopPropagation();
	    	$('#billing-submit').click();
	        }
	});
}


/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
	var $paymentMethods = $('.payment-method');
	var $billingForm = $('[id$="_billing"]');
	var dataMethod = paymentMethodID;
	
	// ensure checkbox of payment method is checked
	$('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
	$('input[name$="_selectedPaymentMethodID"][value=' + paymentMethodID + ']').prop('checked', 'checked');
	
	if($('.payment-method-options').length > 0) {
	
		if(paymentMethodID =="AdyenComponent") {
			// All adyen payments
			$(".other-payment-options").removeClass("alternate-selected");
			$('.other-payment-contain').removeClass('showCheckoutComponent');
			if($($billingForm).valid()) {
				$('.continue').attr("disabled", false);
			}
		} else {
			// Other payment direct PayPal
			$(".other-payment-options").addClass("alternate-selected");
			if($($billingForm).valid()) {
				if(!Constants.IS_OOB_SESSION || (Constants.IS_OOB_SESSION && isOOBPaymentInstrumentsConfirmed)) {
					$('.continue').attr("disabled", false);
				}	
			}
			$('.checkoutComponent').hide();
			$('input[id^="is-klarna"]').removeAttr('checked');
			$('input[name="brandCode"]').removeAttr('checked');
			$('#adyenStateData').val('');
			$('#billing-submit').click();
			
			// Auto click
			$('#billing-submit').bind('customClick', function() {
				$('#billing-submit').click();
				setTimeout(function(){
					if( ($('#same-as-shipping').is(":checked") || $('.select-billing-address').find('.error-placement').length == 0) &&  !$('.checkoutComponent').is(':visible')){			    			
						$('.ajax-loader').show();
					}
				}, 50);	
			});
   
			$('#billing-submit').trigger('customClick');
		}
		
		//klarna dorpdown error handling
		removeAdyenDropdownError();
		$('.component-container select').selectmenu({
			classes: {
				"ui-selectmenu-menu": "klarna-select"
			}
		});
	}
}

function removeAdyenDropdownError() {
	if($(".checkoutComponent span.error").length > 0) {
    	$(".checkoutComponent").removeClass('invalidinput');
    	$(".checkoutComponent span.error").remove();
	}
}

function handleDisplayselectedCard(currentcard, $selectedCards) {
	if($selectedCards) {
		$selectedCards.find('.card-icon').addClass('other-cards');
		$selectedCards.find("[data-card-type='" + currentcard + "']").removeClass('other-cards').addClass("current-card");
	}

}

function initCache() {
	$cache = {};

	$cache.checkoutForm = $(".checkout-billing");
	$cache.selectedCardIdInput = $cache.checkoutForm.find('input[name$="_selectedCardID"]');
}


function setSelectedCardID(uuid) {
	$cache.selectedCardIdInput.val(uuid);
}

function enableCountryField(status) {
	var countryField = $('select[id$="billing_billingAddress_addressFields_country"]');
	if (status) {
		countryField.removeAttr('disabled');
	} else {
		countryField.prop('disabled', true);
	}
}

function addCVNEvent() {
	$('input[name$="creditCard_cvn"]').on('keydown', function (e) {
		if (e.key.toString().match(/[\d]/) ||
			$.inArray(e.keyCode, [8, 9, 13, 46, 33, 34, 35, 36, 37, 38, 39, 40]) >= 0) {
			// do nothing
		} else {
			e.preventDefault();
			e.stopPropagation();
			return;
		}
	});
}
function openpaybylink() {
	$('input[name="paymentmethods-option"]').on('click',function (e) {
		if($(this).val().toLowerCase() =='paybylink') {
			e.preventDefault();
			e.stopPropagation();
			paybylink.open();
			$("#payment-paybylink-order-model-content").addClass('payment-paybylink-popup');
			/*customModal.createCustomModal('payment-paybylink-popup');
			$('.payment-paybylink-popup').find('.modal-body').html(Resources.PAYMENT_PAYBYLINKORDER);
			$('.payment-paybylink-popup').find('.modal-body').scrollBox();*/
			$('input[name$="_selectedPaymentMethodID"]').val('paybylink');
			$(this).prop('checked', 'checked');
			addOOBPaymentInstrument('PayByLink');
		}
	});
}
function openfreeorder() {
	$('input[name="paymentmethods-option"]').on('click',function (e) {
		if($(this).val().toLowerCase() == 'freeorder'){
			e.preventDefault();
			e.stopPropagation();
			freeorder.open();
			$("#payment-free-order-model-content").addClass('payment-paybylink-popup');
			/*customModal.createCustomModal('payment-paybylink-popup');
			$('.payment-paybylink-popup').find('.modal-body').html(Resources.PAYMENT_FREEORDER);
			$('.payment-paybylink-popup').find('.modal-body').scrollBox();*/
			$('input[name$="_selectedPaymentMethodID"]').val('freeorder');
			$(this).prop('checked', 'checked');
			addOOBPaymentInstrument('FreeOrder');
		}
	});
}
function addOOBPaymentInstrument(orderType) {
	var addOrderOnBehalfPIUrl = Urls.addOrderOnBehalfPI;
	$(document).on('click', '.confirm-paybylink-order, .confirm-free-order', function () {	
		$.ajax({
			url: addOrderOnBehalfPIUrl,
			data: {
				orderType : orderType
			},
			success: function (response) {
				if(response.success) {
					isOOBPaymentInstrumentsConfirmed = true;
					$('#billing-submit','.billing-continue-container').attr("disabled", false);
					$("#billing-submit").trigger('click');
				}
			}
		});
	});	
}

//address modal close
function addressModalClose() {
	$(document).on("click", ".edit-add-address .cancel-button", function () {
		$(this).closest('.modal-overlay').remove();
		$('html').removeClass('modal-open');
		$('body').removeClass('body-fixed');
	})
}

/**
* @function
* @description Changes the payment type or issuerId of the selected payment method
* @param {String, Boolean} value of payment type or issuerId and a test value to see which one it is, to which the payment type or issuerId should be changed to
*/
function updatePaymentType(selectedPayType, issuerType) {
	if(issuerType){
	  $('#dwfrm_adyPaydata_issuer').val(selectedPayType);
	}
	else{
	  $('input[name="brandCode"]').removeAttr('checked');
	  $('input[value=' + selectedPayType + ']').prop('checked', 'checked');
	}
	// if the payment type has hidden fields reveal it
	$('#component_' + selectedPayType).show();
	try{
		formPrepare.validateForm();
	} catch (err) {
		console.log(err);
	}
}


function getAddressFromTile() {
	var $selectedAddress = $(".address-tile.selected address");

	return {
		address1: $selectedAddress.data("address-one"),
		address2: $selectedAddress.data("address-two") || "",
		countryCode: $selectedAddress.data("country-code"),
		stateCode: $selectedAddress.data("state-code"),
		postalCode: $selectedAddress.data("postal-code"),
		city: $selectedAddress.data("city")
	};
}

/*
 * Valid Postal and City
 */

function getValidPostalCity(addressId,displModal,disableBut){
	if(!Constants.IS_OOB_SESSION || (Constants.IS_OOB_SESSION && isOOBPaymentInstrumentsConfirmed)) {
		disableBut == true ? $('#billing-submit').removeAttr('disabled') : '';
	}	
	if(displModal){
		reintAddressModalDef(addressId);
	}
}

/**
 * re-init address modal with error
 */
function reintAddressModal(addressID){
	$.ajax({
		url: Urls.checkoutEditBillingAddress + encodeURIComponent(addressID),
		dataType: 'html',
		success: function (response) {
			if (response.indexOf('header-wrapper') === -1) {
				index = require('../product/index');
				customModal.createCustomModal('edit-add-address');
				$('.edit-add-address').find('.modal-body').html(response);
				index.bodyPositionFixed('edit-add-address');
				$('.ajax-loader').hide();
				addressModalClose();
			}
		}
	}).always(function (data) {
		checkoutAddress.init();
		$('#editprofile .postal').val('');
		$('#editprofile .city').val('');
		
		$('select').selectmenu();
		//validator.initStateValidation();
		//validator.initCountryChangeValidation();
		validator.initForm('form[id="EditAddressForm"]');
		var setDefaultCheckbox = $('input[id$="_setdefault"]');
		newAddressForm.init();
		//prepopulate both Phone fields while editting
		newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
		if (setDefaultCheckbox.prop('checked')) {
			setDefaultCheckbox.attr('disabled', 'true');
		}
		$('.edit-add-address .modal-body').scrollBox();
		//Hide addressname on billing
		if ($('.pt_checkout').length > 0 && $('.addressname').length > 0) {
			$('.edit-add-address').find('.addressname').addClass('hidden');
		}
		$('.add-edit-address-cta').click();
		
	});
}

// Checkout Newsletter Optin Consent
function initializeOptinContainer() {
	if($('.checkout-main-wrapper .hide-btn-container').length){
		$('.checkout-main-wrapper .show-content-wrapper').remove();
	}
	// Checkbox toggle to show contnet
	$('.pt_checkout .order-summary-footer').on('click', '.checkout-newsletter-optin input[type="checkbox"]', function () {		
		const $element = $(".newsletter-optin-secondary-text");
		if($(this).prop("checked") == true) {
			$element.removeClass("hide-text");
		} else {
			$element.addClass("hide-text");
		}
	});	
	// Show more content
	$('.checkout-newsletter-optin').on('click', '.see-more-consent', function () {
		var parentContainer = $(this).parents('.checkout-newsletter-optin');
		$(this).removeClass('is-active');
		$(parentContainer).find('.secondary-text').addClass('is-active');
		$(parentContainer).find('.see-less-consent').addClass('is-active');
	});
	// Show less content
	$('.checkout-newsletter-optin').on('click', '.see-less-consent', function () {
		var parentContainer = $(this).parents('.checkout-newsletter-optin');
		$(this).removeClass('is-active');
		$(parentContainer).find('.secondary-text').removeClass('is-active');
		$(parentContainer).find('.see-more-consent').addClass('is-active');
	});
}


/**
 * re-init address modal with error
 */
function reintAddressModalDef(addressID){
	
	$.ajax({
		url: Urls.checkoutEditBillingAddress + encodeURIComponent(addressID),
		dataType: 'html',
		success: function (response) {
			if (response.indexOf('header-wrapper') === -1) {
				index = require('../product/index');
				customModal.createCustomModal('edit-add-address');
				$('.edit-add-address').find('.modal-body').html(response);
				index.bodyPositionFixed('edit-add-address');
				$('.ajax-loader').hide();
				addressModalClose();
			}
		}
	}).always(function (data) {
		$('select').selectmenu();
		checkoutAddress.init();
		//validator.initStateValidation();
		//validator.initCountryChangeValidation();
		validator.initForm('form[id="EditAddressForm"]');
		var setDefaultCheckbox = $('input[id$="_setdefault"]');
		newAddressForm.init();
		//prepopulate both Phone fields while editting
		newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
		if (setDefaultCheckbox.prop('checked')) {
			setDefaultCheckbox.attr('disabled', 'true');
		}
		$('.edit-add-address .modal-body').scrollBox();
		//Hide addressname on billing
		if ($('.pt_checkout').length > 0 && $('.addressname').length > 0) {
			$('.edit-add-address').find('.addressname').addClass('hidden');
		}
	});
}


function initRightCTAClick() {
	$(document).on('click', '.bg-blue-secondary .excluded-continue ', function() {
		$(".billing-continue-container .continue").trigger("click");
	});
}

const countryPopinSelector = function () {
    $('select.country').selectmenu({
		classes: {
			"ui-selectmenu-menu": "country-select-menu"
		}
	}); 
}

if ($(".de-form-redesign").length) {
	selectMenu.selectMenuWithCountryFlag();
}

/**
 * @function
 * @description loads billing address, Coupon and Payment methods
 */
export default {
	init: function () {
	//cardValidation.init();
	if(Constants.IS_OOB_SESSION) {
		openfreeorder();
		openpaybylink();
		$('#billing-submit').attr("disabled", true);
		$('#billing-submit').on('click', function () {
			if(!isOOBPaymentInstrumentsConfirmed) {
				event.preventDefault();
				return false;
			}
		});
		
		$(document).on('click', '.modal-close, .modal-close-outer, .modal-close-btn', function () {
			if(!isOOBPaymentInstrumentsConfirmed) {
				$('#billing-submit','.billing-continue-container').attr("disabled", true);
			}	
		});
	}	
	initCache();
	summarysection.init();
	//validator.initCountryChangeValidation();
	googleAddressAutocomplete.init();
	newAddressForm.init();
	newAddressForm.populatePostalHelpText();
	newAddressForm.populatePhoneHelpText();
	// checkout redesign handling

	if($(".applepay-container-wrapper").length) {
        $('.applepay-container-wrapper, .applepay-container-wrapper button').hide();
    }

	if($(".de-checkout-redesign").length) {
		initRightCTAClick();
		countryPopinSelector();
		selectMenu.selectMenuWithCountryFlag();
		inputField.init();
		util.limitCharactersText();
		util.characterLimitEventsText();
	}

	$(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country', function() {
        var currentElement = $(this);
        var selectContry = $(currentElement).val();
        var $form = $(currentElement).closest('form');
        //populate the tooltip for different markets
        if(selectContry !== undefined && selectContry !== ''){
            tooltip.init();
        }
        
        if (selectContry == '') {
            toggleBillingAddressFields(true);
        } else if (selectContry == 'us' || selectContry == 'ca'){
            toggleBillingAddressFields(true);
            $(".us-fields").show();
            $(".cn-fields").hide();
            $form.find('.postcode').removeClass('required');
            $form.find('.province').removeClass('required');
        } else {
            toggleBillingAddressFields(true);
            
            //pre-populate the Country Calling Code for phone field
            util.prePopulateCallingCountryCode($(this).val());
            util.handleCountryCodeUpdate($form.find('input[name$="_phone"]'));
            var selectedCountryCode = $(this).val().toLowerCase();
            newAddressForm.populatePostalHelpText(selectedCountryCode);
            newAddressForm.populatePhoneHelpText(selectedCountryCode);
            if($('#modal-cntr').hasClass('edit-add-address')) {
                var addrphvalue = $('.input-text.phonenumber');
                if(addrphvalue.val()) {
                    addrphvalue.val('');
                }
            }
            
            $(".cn-fields").show().css({"display" : "flex"});

            $form.find('.postcode').addClass('required').rules('add', {
                required: true,
                postal: true,
                messages: {
                    postal: Resources.INVALID_POSTAL
                }
            });
            $form.find('.province').addClass('required').rules('add', {
                required: true,
                simpletext: true,
                messages: {
                    simpletext: Resources.VALIDATE_PROVINCE
                }
            });
        }
    });


	$(document).on('click', '.billing .address-create', function () {
		modal.setCallback(function() {
			toggleBillingAddressFields(true);
		});

		toggleBillingAddressFields(true);
		modal.addCustomClass('edit-add-address');
		modal.events.onOpen(function() {
			validator.initForm('form[id="EditAddressForm"]');
			tooltip.init();
			checkoutAddress.init();
			googleAddressAutocomplete.init();
		});

		modal.renderByUrl(Urls.checkoutAddBillingAddress); 
		util.phoneAccountAddressModal();
		util.postalAccountAddressModal();

		// fetch the country code
		setTimeout(() => {
			var $form = $('form[id$="EditAddressForm"]');
			var $savedCountry = $form.find('select[name$="_country"]').val();
			$savedCountry = $savedCountry.toLowerCase();
			var countryCode = util.getCallingCountryCode($savedCountry);
			var phoneField =  $form.find('input[name$="_phone"]');
			phoneField.attr('data-country-code', countryCode);
			$('input[id$="_areaCode"]').val(countryCode);
			newAddressForm.populatePostalHelpText();
			newAddressForm.populatePhoneHelpText();
		}, 1500);
		})

		// close modal on cancel button click
		.on('click', '.cancel-done-button-wrapper .cancel-button', function (e) {
			e.preventDefault();
			modal.close();
		})

		// edit address link
		.on("click", ".billing .address-edit", function (evt) {
			var $this = $(this);
			var addressID = $this.data('addressId');
			// $('.ajax-loader').show();
			// getValidPostalCity(addressID,true,false);
			var url = Urls.checkoutEditBillingAddress + encodeURIComponent(addressID);

			    modal.setCallback(function() {
					toggleBillingAddressFields(true);
			    });
			    modal.events.onOpen(function() {
				   validator.initForm('form[id$="EditAddressForm"]');
				   var $form = $('form[id$="EditAddressForm"]');

				   var savedCountry = $('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country');
				   $('select[name$="_country"]').val(savedCountry);
				   var countryCode = util.getCallingCountryCode(savedCountry);
				   var phoneFiled =  $form.find('input[name$="_phone"]');
				   phoneFiled.attr('data-country-code', countryCode);
				   util.handleCountryCodeUpdate(phoneFiled);
				   tooltip.init();
				   checkoutAddress.init();
				   googleAddressAutocomplete.init();
				   var setDefaultCheckbox = $('input[id$="_setdefault"]');
					if (setDefaultCheckbox.prop('checked')) {
						setDefaultCheckbox.attr('disabled', 'true');
					}
			    });

				modal.addCustomClass('edit-add-address');
				modal.renderByUrl(url);
				setTimeout(() => {
					var phoneValue = $('#dwfrm_billing_billingAddress_addressFields_phone').val();
					newAddressForm.init();
					newAddressForm.populatePhoneFields(phoneValue);
					newAddressForm.populatePostalHelpText();
					newAddressForm.populatePhoneHelpText();
				}, 1500);			
		});

	var $selectPaymentMethod = $('.payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.find('input[name$="_selectedPaymentMethodID"]:checked').val();
    $cache.$payType = $('[name="brandCode"]');
    var $issuer = $('.issuer');
    var selectedPayType = $cache.$payType.find(':checked').val();
	//validator.initStateValidation();
	validator.initForm('form[id$="billing"]');

	function toggleBillingAddressFields(visible) {
		if (visible == true) {
			$('.country-dependent').each(function () {
				$(this).show();
			});
		} else {
			$('.country-dependent').each(function () {
				$(this).hide();
			});
		}

		if (window.User.isCustomerAuthenticated == false) {
			$('.checkout-billing').find('.set-default-cb').hide();
		}
	}

	$(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country, #dwfrm_billingaddress_country', function () {
		var selectContry = $(this).val();
		if (selectContry == '') {
			toggleBillingAddressFields();
		} else if (selectContry == 'us') {
			toggleBillingAddressFields(true);
			$('.us-fields').show();
			$('.us-fields input').each(function () {
				$(this).addClass('required');
			});

			$('.cn-fields').hide();
			$('.cn-fields input').each(function () {
				$(this).removeClass('required');
			});
		} else {
			toggleBillingAddressFields(true);
			$(".cn-fields").show().css({
				"display": "flex"
			});
			$('.cn-fields input').each(function () {
				$(this).addClass('required');
			});

			$('.us-fields').hide();
			$('.us-fields input').each(function () {
				$(this).removeClass('required');
			});
		}
	});

	$('.billing-address-section :input').on('change', function (e) {
		if (e.target.id == 'dwfrm_billing_billingAddress_useAsBillingAddress') {
			return false;
		}

		$('#dwfrm_billing_billingAddress_useAsBillingAddress').prop('checked', false);
	});

	$('input#same-as-shipping').on('change', function () {
		var sameascheckbox = $(this);

		if (sameascheckbox.is(":checked")) {
			$('.saved-addresses.select-billing-address').addClass('hidden');
			$('.saved-addresses.default-billing-address').removeClass('hidden');

			$('#dwfrm_billing_billingAddress_addressFields_firstName').val($('#dwfrm_billing_billingAddress_addressFields_firstName').attr('data-firstname'));
			$('#dwfrm_billing_billingAddress_addressFields_lastName').val($('#dwfrm_billing_billingAddress_addressFields_lastName').attr('data-lastname'));
			if ($('#dwfrm_billing_billingAddress_addressFields_lastName2').length > 0) {
				$('#dwfrm_billing_billingAddress_addressFields_lastName2').val($('#dwfrm_billing_billingAddress_addressFields_lastName2').attr('data-lastname2'));
			}
			$('#dwfrm_billing_billingAddress_addressFields_address1').val($('#dwfrm_billing_billingAddress_addressFields_address1').attr('data-address1'));
			$('#dwfrm_billing_billingAddress_addressFields_address2').val($('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2'));
			$('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
			$('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
			$('#dwfrm_billing_billingAddress_addressFields_postal').val($('#dwfrm_billing_billingAddress_addressFields_postal').attr('data-postal'));
			$('#dwfrm_billing_billingAddress_addressFields_country').val($('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country'));
			$('#dwfrm_billing_billingAddress_addressFields_states_state').val($('#dwfrm_billing_billingAddress_addressFields_states_state').attr('data-state'));
			$('#dwfrm_billing_billingAddress_addressFields_phone').val($('#dwfrm_billing_billingAddress_addressFields_phone').attr('data-phone'));
			newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
			$('#sameAsShippingAddress').val(false);


			// for logged-in users with address, reselect default shipping address
			// if customer chooses to use the shipping address as their billing address
			var selectedShipping = $('div.address-tile.address-default');
			if (selectedShipping) {
				selectedShipping.removeClass('selected');
				selectedShipping.removeClass('default');
				selectedShipping.click();
			}
		} else {
			$('.saved-addresses.default-billing-address').addClass('hidden');
			$('.saved-addresses.select-billing-address').removeClass('hidden');
			$('.checkout-billing').find('.addressname').addClass('hidden');
			newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
			$('#dwfrm_billing_billingAddress_addressFields_firstName').val('');
			$('#dwfrm_billing_billingAddress_addressFields_lastName').val('');
			if ($('#dwfrm_billing_billingAddress_addressFields_lastName2').length > 0) {
				$('#dwfrm_billing_billingAddress_addressFields_lastName2').val('');
			}	
			$('#dwfrm_billing_billingAddress_addressFields_address1').val('');
			$('#dwfrm_billing_billingAddress_addressFields_address2').val('');
			$('#dwfrm_billing_billingAddress_addressFields_city').val('');
			$('#dwfrm_billing_billingAddress_addressFields_postal').val('');
			$('#dwfrm_billing_billingAddress_addressFields_phone').val('');
			$('#dwfrm_billing_billingAddress_addressFields_phoneNumber').val('');
			$('#dwfrm_billing_billingAddress_addressFields_postcode').val('');
			$('#dwfrm_billing_billingAddress_addressFields_province').val('');
			$('#dwfrm_billing_billingAddress_addressFields_states_state').val('');
			$('#dwfrm_billing_billingAddress_addressFields_states_state').selectmenu('refresh');
			$('#sameAsShippingAddress').val(true);
			$('.checkout-billing').find('.set-default-cb').addClass('hidden');
			googleAddressAutocomplete.init();
		}
	});

	// default payment method to 'CREDIT_CARD'
	updatePaymentMethod('AdyenComponent');

	$selectPaymentMethod.on('click', 'input[name$="_selectedPaymentMethodID"]', function () {
    	updatePaymentMethod($(this).val());
    	if ($(this).val() == 'Adyen' && $cache.$payType.length > 0) {
            // set payment type of Adyen to the first one
            updatePaymentType((selectedPayType) ? selectedPayType : $cache.$payType[0].value, false);
        } else {
        	//$cache.$payType.removeAttr('checked');
        }
	});
	
	$cache.$payType.on('click', function () {
    	updatePaymentType($(this).val(), false);
		$('input[value="AdyenComponent"]').prop('checked', 'checked').trigger('click');

		if(Constants.KLARNA_GRP_METHOD.indexOf($(this).val()) > -1) {
			if($('.single-klarna-option').length > 0) {
				$('#billing-submit').unbind('customClick');
			} else {
                $('#billing-submit').trigger('click');
            }
			$('.klarna-component').on('selectmenuchange change', function () {
				$('input[id^="is-klarna"]').val($(this).val());
				$('#billing-submit').trigger('click');
			});
		}
    });
	
	$issuer.on('change', function () {
    	updatePaymentType($(this).val(), true);
    });

	$(document).ready(function() {		
		$(document).on('click', '.address-list .address-tile', function (evt) {
			if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
				return false;
			} else {
				$('.address-list .address-tile').each(function () {
					$(this).removeClass('selected');
					$(this).removeClass('default');
				});
	
				$(this).addClass('selected');
	
				var element = document.getElementById(evt.currentTarget.id);
				var addressID = element.dataset.addressId;
	
				var url = util.appendParamsToUrl(Urls.updateBillingAddressDetails, {
					addressID: addressID
				});
				$.ajax({
					url: url,
					type: 'GET',
					success: function (result) {getValidPostalCity(addressID,false,true);	}
				});
			}
		});
	});

	$('.order-summary-footer form').submit(function () {
		$('#summary-place-order, #sticky-place-order').prop('disabled', true).addClass('loading');
		return true;
	});
	
	$(document).ready(function() {
		//update the checkobox with backend value
		if ($('input#same-as-shipping').length > 0  &&  $('#sameAsShippingAddress').val() == null) {
			$('input#same-as-shipping').prop('checked', true);
			$('input#same-as-shipping').trigger('change');
		}
		// if same as shipping is checked, re-select default address
		// or if nothing is selected, re-select default address
		if (($('input#same-as-shipping').length > 0 && $('input#same-as-shipping').is(":checked") &&  $('#sameAsShippingAddress').val() == null) ||
			$('div.address-list div.address-tile.selected').length <= 0) {
					
			$(document).find('div.address-list div.address-tile').each(function (ind, evt) {
				if ($(this).hasClass('default') || $(this).hasClass('selected') || $(this).hasClass('address-default')) {
					$(this).removeClass('selected');
					$(this).removeClass('default');
	
					$(this).trigger('click');
				}
			});
		} else if ($('input#same-as-shipping').length == 0 && $('div.address-list div.address-tile.selected').length > 0) {
			// if no physical product to ship, re-select tile to properly assign billing address
			var reSelectTile = $('div.address-list div.address-tile.selected');
			reSelectTile.removeClass('selected');
			reSelectTile.removeClass('default');
			reSelectTile.trigger('click');
		}
	});

	// trigger click event for selected by default cc (to manually trigger cc code)
	var selectedCC = $('div.payment-method div.creditcard-tile.selected');
	if (selectedCC) {
		selectedCC.removeClass('selected').click();
	}

	// maximize order checkout summary dropdown
	util.maximizeCheckoutSummary();


	// Review step Screen offset
	if (window.innerWidth <= 768) {
		var reviewButton = $('.primary-content .review').find('#summary-place-order');
		if (reviewButton.length > 0) {
			var element = $('.primary-content .review');
			var offset = element.offset();
			var offsetTop = offset.top;
			$('html, body').scrollTop(offsetTop - 200);
		}
	}
	
	
    
	$cache.$payType.on('change', function() {
    	$('#selectedIssuer').val("");
    	$issuer.hide();
    	$('.checkoutComponent').hide();
    	$('#component_' + $(this).val()).show();
    	
    	if ($(this).siblings( ".issuer").length > 0) {
    		$('#selectedIssuer').val($(this).siblings( ".issuer" ).val());
    		$(this).siblings('.issuer').show();
	    }
		if(Constants.KLARNA_GRP_METHOD.indexOf($(this).val()) > -1) {
			$('.klarna-component-wrapper').show();
		}
		else {
			$('.klarna-component-wrapper').hide();
		}
		var $otherPaymentCont = $('.other-payment-contain');
    	if($('.checkoutComponent').length > 0) {
			$('.ajax-loader').hide();
			$otherPaymentCont.addClass('showCheckoutComponent');
			$(".other-payment-options").addClass("alternate-selected");
    	} else {
    		$otherPaymentCont.removeClass('showCheckoutComponent');
    		$(".other-payment-options").removeClass("alternate-selected");
    	}
	});

	function billingTermsErrMsg () {
		if($('.input-checkbox.termsandconditions').is(':checked')) {
			$('.input-checkbox.termsandconditions').siblings('.error').removeClass('errmsg');
			$('.input-checkbox.termsandconditions').removeClass('errortc');
		} else {
			$('.input-checkbox.termsandconditions').siblings('.error').addClass('errmsg');
			$('.input-checkbox.termsandconditions').addClass('errortc');
		}
	}
	$('.input-checkbox.termsandconditions').on('change', function () {
		billingTermsErrMsg ();
    });
	$('#billing-submit').on('click', function () {
		billingTermsErrMsg ();
    });
	 $(window).on('load', function() {
		if($('.input-checkbox.termsandconditions').siblings('.error').hasClass('errmsg')) {
			$('.input-checkbox.termsandconditions').addClass('errortc');
		} else {
			$('.input-checkbox.termsandconditions').removeClass('errortc');
		}

		 if($('#apple-pay-wrapper').find('button.dw-apple-pay-button').length !== 0){
			 $('#apple-pay-wrapper').css('display','block');
		 }

		 if($("#dwfrm_userconsent_termsandconditions-error").is(':visible')){
			$("#dwfrm_userconsent_termsandconditions-error").remove();
		 }
		 
		 //checkoutAddress.init();
		 $cache.$payType = $('[name="brandCode"]').length > 0 ? $('[name="brandCode"]') : console.log('brand code not found');
	 });
	 
	 if (SitePreferences.ADYEN_SF_ENABLED) {
		adyenCheckout.initBilling();
	 }
	 
	 $cache.$payType = $('[name="brandCode"]').length > 0 ? $('[name="brandCode"]') : console.log('brand code not found');

	 initializeOptinContainer();
	}
}